import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Protège une route : redirige vers /login si non connecté,
// ou vers l'accueil si connecté mais pas administrateur (requireAdmin=true).
export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return <div className="auth-loading">Chargement…</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
